import { isHiddenOnKiosk } from './show-on-kiosk';
/** Respond to both floors removed from LH and floors hidden by overrides. */
export const resolveFloorAccess = (location, viewType, selectedFloorId, defaultFloorId, whereAmIFloorId) => {
    const floors = location === null || location === void 0 ? void 0 : location.children;
    if ((viewType !== 'building' && viewType !== 'floor') ||
        !Array.isArray(floors)) {
        return { restricted: false };
    }
    const visibleFloors = floors.filter((floor) => !isHiddenOnKiosk(floor));
    if (visibleFloors.length === 0) {
        if (viewType === 'floor' || defaultFloorId)
            return { restricted: true };
        return selectedFloorId
            ? { restricted: false, redirectFloorId: '' }
            : { restricted: false };
    }
    if (!selectedFloorId)
        return { restricted: false };
    const selectedFloor = floors.find((floor) => floor.id === selectedFloorId);
    if (selectedFloor && !isHiddenOnKiosk(selectedFloor)) {
        return { restricted: false };
    }
    const defaultFloor = visibleFloors.find((floor) => floor.id === defaultFloorId);
    if (defaultFloor) {
        return { restricted: false, redirectFloorId: defaultFloor.id };
    }
    // Ordinary building view prefers a usable Where Am I floor. Default-floor
    // configurations keep their existing default -> lowest priority.
    if (viewType === 'building' && !defaultFloorId) {
        const whereAmIFloor = visibleFloors.find((floor) => floor.id === whereAmIFloorId);
        if (whereAmIFloor) {
            return { restricted: false, redirectFloorId: whereAmIFloor.id };
        }
    }
    const lowestFloor = [...visibleFloors].sort((a, b) => {
        const numberA = Number(a.floorNumber);
        const numberB = Number(b.floorNumber);
        return ((Number.isFinite(numberA) ? numberA : Infinity) -
            (Number.isFinite(numberB) ? numberB : Infinity));
    })[0];
    return { restricted: false, redirectFloorId: lowestFloor.id };
};
